import { Link } from "@inertiajs/react";
import {
  IconBrandYoutube,
  IconBrandInstagram,
  IconBrandFacebook,
} from "@tabler/icons-react";
import styles from "./Footer.module.css";

// TODO tagline copy — swap this string when finalised.
const TAGLINE = "Learn Kizomba, Semba, and the culture behind them.";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>
        <div>
          <div className={styles.brandMark}>Learntokiz</div>
          <div className={styles.tagline}>{TAGLINE}</div>
        </div>

        <div>
          <h3 className={styles.colHead}>Learn</h3>
          <ul className={styles.colList}>
            <li>
              <Link href="/videos" className={styles.link}>
                Free Videos
              </Link>
            </li>
            <li>
              <Link href="/dictionary" className={styles.link}>
                Dictionary
              </Link>
            </li>
            <li>
              <Link href="/posts" className={styles.link}>
                Posts
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className={styles.colHead}>Explore</h3>
          <ul className={styles.colList}>
            <li>
              <Link href="/pricing" className={styles.link}>
                Pricing
              </Link>
            </li>
            <li>
              <Link href="/faq" className={styles.link}>
                FAQ
              </Link>
            </li>
            <li>
              <Link href="/changelog" className={styles.link}>
                Changelog
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h3 className={styles.colHead}>Follow</h3>
          <div className={styles.socialRow}>
            <a
              href="#"
              aria-label="YouTube"
              className={styles.socialIcon}
            >
              <IconBrandYoutube size={20} />
            </a>
            <a
              href="#"
              aria-label="Instagram"
              className={styles.socialIcon}
            >
              <IconBrandInstagram size={20} />
            </a>
            <a
              href="#"
              aria-label="Facebook"
              className={styles.socialIcon}
            >
              <IconBrandFacebook size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className={styles.legalBar}>
        <span>© {year} Learntokiz</span>
        <div className={styles.legalLinks}>
          {/* TODO wire when /about ships */}
          <a href="#" className={styles.link}>
            About
          </a>
          <span className={styles.legalDivider}>·</span>
          {/* TODO wire when /contact ships */}
          <a href="#" className={styles.link}>
            Contact
          </a>
          <span className={styles.legalDivider}>·</span>
          <a href="#" className={styles.link}>
            Privacy
          </a>
          <span className={styles.legalDivider}>·</span>
          <a href="#" className={styles.link}>
            Terms
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
